var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.354,
    height: 47.619,
    viewBox: "0 0 48.354 47.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1678",
    "data-name": "Grupo 1678",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    "data-name": "Trazado 236",
    d: "M417.2,345.365l8.4-10.794-.506,13.666,13.371-2.872-9.172,10.143L441.38,361.9l-13.546,1.874,5.15,12.669L421.4,369.174l-4.2,13.015L413,369.174l-11.582,7.272,5.15-12.669L393.026,361.9l12.088-6.395-9.172-10.143,13.371,2.872-.506-13.666Z",
    transform: "translate(-393.026 -334.57)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "behance-logo",
    transform: "translate(16.988 18.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_257",
    "data-name": "Grupo 257",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    d: "M6.246,21.946A1.666,1.666,0,0,0,7.71,20.119a2.453,2.453,0,0,0-2.716-2.555H0v9.6H4.994s3.049.1,3.049-2.833C8.043,24.329,8.176,21.946,6.246,21.946ZM2.2,19.27H4.994s.679,0,.679,1-.4,1.143-.852,1.143H2.2Zm2.665,6.186H2.2V22.891H4.994s1.012-.013,1.012,1.318C6.006,25.319,5.266,25.445,4.865,25.456Z",
    transform: "translate(0 -17.564)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_621",
    "data-name": "Rect\\xE1ngulo 621",
    width: 3.96,
    height: 1.182,
    transform: "translate(10.044 0.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    d: "M55.8,32.682c-3.691,0-3.688,3.687-3.688,3.687A3.405,3.405,0,0,0,55.8,40.038s3.284.188,3.284-2.552H57.4s.056,1.032-1.539,1.032a1.561,1.561,0,0,1-1.689-1.67h4.973S59.688,32.682,55.8,32.682Zm1.5,2.885H54.152a1.716,1.716,0,0,1,1.689-1.479A1.428,1.428,0,0,1,57.3,35.567Z",
    transform: "translate(-43.695 -30.24)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceIconColor);
export default __webpack_public_path__ + "static/media/behance_icon_color.3eefb47323623d8dfce971d3006d07de.svg";
export { ForwardRef as ReactComponent };